import { FC } from "react";
import { DonutChartLined } from "@tag/tag-icons";
import "./dailySalesMetrics.css";
import { useForecastContext } from "../../../../context/forecastContext";
import { useTheme } from "../../../../context/themeContext";
import SkeletonLoader from "../../../SkeletonLoader";
import ErrorMessage from "../../../errorMessage/errorMessage";
import dayjs from "dayjs";
import { findForecastForDay } from "../../../../utilities/forecastHelpers";
import { useForecastQuery } from "../../../../services/forecastService";

type DailySalesMetricsProps = {};

const DailySalesMetrics: FC<DailySalesMetricsProps> = () => {
  const { theme } = useTheme();
  const { forecastState } = useForecastContext();

  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Forecast" fontSize="13px" />;
  }

  const forecast = findForecastForDay(
    dayjs(forecastState.selectedDate).format("YYYY-MM-DD"),
    forecasts ?? []
  );

  // if (!forecast) {
  //   return <SkeletonLoader />;
  // }

  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div className="daily-sales-metrics-container">
      <div className="daily-sales-metrics-header">
        <div className="daily-sales-metrics-header-title">
          <span>
            <DonutChartLined accent="teal" /> {"Sales Metrics"}
          </span>
        </div>
      </div>
      <div className="daily-sales-metrics-content-container"></div>
    </div>
  );
};

export default DailySalesMetrics;
